module.exports = {
      id: "health-usage",
      viewBox: "0 0 26.46 26.46",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#health",
      toString: function () {
        return this.url;
      }
    }